import type { CurrencyFormat } from '@/entities/wallet/types';

export const DEFAULT_CURRENCY_FORMAT: CurrencyFormat = {
  currency: 'BRL',
  decimalSep: ',',
  minorUnit: 2,
  symbol: 'R$',
  symbolPosition: 'prefix',
  thousandSep: '.',
};

const groupThousands = (intDigits: string, thousandSep: string): string =>
  intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);

/**
 * 按币种格式把最小货币单位（分）格式化为展示字符串。
 * 多国家口径：符号、小数位、分隔符均由 currency_config 下发，不在前端硬编码。
 */
export const formatMinor = (
  amountMinor: number,
  format: CurrencyFormat = DEFAULT_CURRENCY_FORMAT,
  withSymbol = true,
): string => {
  const negative = amountMinor < 0;
  const abs = Math.abs(Math.trunc(amountMinor));
  const factor = 10 ** format.minorUnit;
  const intPart = Math.floor(abs / factor);
  const fracPart = abs % factor;

  let numberStr = groupThousands(String(intPart), format.thousandSep);
  if (format.minorUnit > 0) {
    const fracStr = String(fracPart).padStart(format.minorUnit, '0');
    numberStr = `${numberStr}${format.decimalSep}${fracStr}`;
  }

  const signed = negative ? `-${numberStr}` : numberStr;
  if (!withSymbol) return signed;
  return format.symbolPosition === 'suffix'
    ? `${signed} ${format.symbol}`
    : `${format.symbol} ${signed}`;
};

/**
 * 带正负号展示账变金额。
 */
export const formatSignedMinor = (
  amountMinor: number,
  isCredit: boolean,
  format: CurrencyFormat = DEFAULT_CURRENCY_FORMAT,
): string => {
  const sign = isCredit ? '+ ' : '- ';
  return `${sign}${formatMinor(Math.abs(amountMinor), format)}`;
};
